import { venueConfig } from '@beat-venues/common-types';
import { Heading, Text, TextLink, VenueLogoList } from '@beat-venues/ui/react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export const LayoutNoEvents = (): ReactElement => {
    const { t, i18n } = useTranslation();

    return (
        <div className="rounded-xl border-2 border-dotted border-white p-12">
            <div className="flex flex-col gap-6">
                <div className="m-auto md:w-4/5">
                    <Heading>{t('noEvents.title')}</Heading>
                    <Text>{t('noEvents.titleDescription')}</Text>
                    <Heading as="h4" className="mt-4">
                        {t('noEvents.explore')}
                    </Heading>
                    <Text>{t('noEvents.exploreDescription')}</Text>
                </div>
                <VenueLogoList
                    className="max-w-container-lg -mt-8"
                    includeBeat={true}
                />
                <div className="m-auto md:w-4/5">
                    <Heading as="h4">{t('noEvents.notSure')}</Heading>
                    <Text>
                        {t('noEvents.notSureDEscription1')}
                        <TextLink
                            href={`${venueConfig('beat-tickets', 'vite').url}/${
                                i18n.language
                            }`}
                        >
                            {t('noEvents.notSureLink')}
                        </TextLink>
                        {t('noEvents.notSureDEscription2')}
                    </Text>
                </div>
            </div>
        </div>
    );
};
